/*
 * @Author: Roman
 * @Date: 2023-04-21 15:04:02
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-05-10 16:03:42
 * @FilePath: \qpmn-site\src\app\modules\user\rest\account\rest\users-rest.service.ts
 * @Description: 
 */
import { AbstractAccessorService, IDataAccessor } from "@core/data-access";
import { IUserInfo } from "@modules/user/model/domain/account/UserInfo";
import { IUsersRestService } from "./users-rest";
import type { IResponse } from "@core/data-access/model";
import { appConfig } from "@env/app-config";

export class UsersRestService extends AbstractAccessorService<IUserInfo> implements IUsersRestService {

    public readonly $name: string = "usersRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IUserInfo>) {
        super();
    }

    public modifyV2(userInfo: IUserInfo): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, IUserInfo, string>(this.$name, "modifyV2", {
            data: { 
                ...userInfo
            }
        })
    }

    /**
     * @description: 在新的修改用户信息中修改密码，此接口废弃
     * @deprecated
     */    
    public changePassword(oldPassword: string, password: string): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, { oldPassword: string, password: string }, string>(this.$name, "changePassword", {
            data: {
                oldPassword: oldPassword,
                password: password
            }
        });
    }

    /**
     * @description: 因为需要使用到google验证码，所以修改邮箱仍用此接口
     */
    public modifyEmail(emailAddress: string,googleResponse: string): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, any, string>(this.$name, "modifyEmail", {
            data: {
                emailAddress: emailAddress,
                platform: appConfig.websiteCode,
                googleResponse: googleResponse
            }
        });
    }

    public mailValidation(token: string): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, { token: string }, string>(this.$name, "mailValidation", {
            parameter: {
                token: token
            }
        });
    }
}